import React from 'react';
import classNames from 'classnames';
import style from './App.less';

import { injectIntl } from 'react-intl';
import { inject, toggleInject } from "../components/injector";

import hlepIcon from './image/helpIcon.png';
import enhlepIcon from './image/enhelpIcon.png';
import hlepIcon2 from './image/helpIcon2.png';
import frhlepIcon from './image/frhlepIcon.png';
import eshlepIcon from './image/eshlepIcon.png';

const imgArr={
    zh:hlepIcon,
    en:enhlepIcon,
    fr:frhlepIcon,
    es:eshlepIcon
}
class Help extends React.PureComponent {
    componentDidMount() {
        document.title = this.props.intl.formatMessage({ id: 'help' })
    }

    strs = (id) => {
        const { formatMessage } = this.props.intl;
        const data = formatMessage({ id: id });
        return data.replace(/(\r\n)|(\n)/g, '<br/>');
    };
    
    render() {
        const { pwr, intl, history } = this.props;
        const language =intl.locale.toLowerCase().split('-')[0];
        console.log('img-----',language);
        console.log('img2-----',imgArr[language]);
        
        return (
            <div className={style.helpPage}>
                <div dangerouslySetInnerHTML={{ __html: this.strs('helpContent') }}></div>
                <div className={style.helpIcon}><img src={imgArr[language]||enhlepIcon} /></div>
                <div dangerouslySetInnerHTML={{ __html: this.strs('helpmContent') }}></div>
                <div className={style.bicon}><img src={hlepIcon2} /></div>
                <div dangerouslySetInnerHTML={{ __html: this.strs('helpbContent') }}></div>
            </div>
        )
    }
}



export default inject()(injectIntl(Help));